import { trim, isEmpty } from 'lodash';

export const wrapText = (text, maxLength = 50) => {
  if (isEmpty(text) || text.length <= maxLength) return text;

  const words = text.split(' ');
  let currentLine = '';
  const lines = [];

  words.forEach((word) => {
    if ((currentLine + word).length > maxLength) {
      lines.push(trim(currentLine));
      currentLine = `${word} `;
    } else {
      currentLine += `${word} `;
    }
  });

  if (currentLine) {
    lines.push(trim(currentLine));
  }

  return lines.join('<br>');
};
